var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 28,
    viewBox: "0 0 21 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75391 4.9375V22H5.83594V4.9375H8.75391ZM14.1094 4.9375V7.28125H0.527344V4.9375H14.1094Z",
    fill: "#262626"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8359 11.625V23H14.8906V11.625H16.8359ZM20.4062 11.625V13.1875H11.3516V11.625H20.4062Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextIcon);
export default __webpack_public_path__ + "static/media/text-icon.74440c132f3db4fa6140dae789cc5797.svg";
export { ForwardRef as ReactComponent };